import {createStore} from "vuex";
import {indexModule} from "@/store/indexModule";
import {messageModule} from "@/store/messageModule";
import {authorizationModule} from "@/store/authorizationModule";
import {profileModule} from "@/store/profileModule";
import {financeModule} from "@/store/financeModule";
import {assistantModule} from "@/store/assistantModule";
import {tariffModule} from "@/store/tariffModule";
import {adminModule} from "@/store/adminModule";
import {detailingModule} from "@/store/detailingModule";
import router from "@/router/router"

let lang = localStorage.getItem('locale');

export default createStore({
    state: () => ({
        
    }),
    getters: {
        
    },
    mutations: {
        clientError() {
            if(lang === 'ru'){
                toastr.error("Произошла ошибка на стороне клиента (некорректный запрос) повторите попытку позже или свяжитесь с оператором");
            }else if(lang === 'kz'){
                toastr.error("Клиент жағында қате орын алды (жарамсыз сұрау), әрекетті кейінірек қайталаңыз немесе операторға хабарласыңыз");
            }else{
                toastr.error("An error occurred on the client side (invalid request), please try again later or contact the operator");
            }
            // router.push('/error/400')
        },
        serverError() {
            if(lang === 'ru'){
                toastr.error("Произошла ошибка на стороне сервера (внутренняя ошибка сервера) повторите попытку позже или свяжитесь с оператором");
            }else if(lang === 'kz'){
                toastr.error("Сервер жағында қате орын алды (ішкі сервер қатесі) әрекетті кейінірек қайталаңыз немесе операторға хабарласыңыз");
            }else{
                toastr.error("An error occurred on the server side (internal server error) please try again later or contact the operator");
            }
            // router.push('/error/500')
            // preloader.classList.contains('d-none') || preloader.classList.add('d-none');

        },
    },
    modules: {
        personaldata: indexModule,
        messages: messageModule,
        authorization: authorizationModule,
        profile: profileModule,
        finance: financeModule,
        assistant: assistantModule,
        tariff: tariffModule,
        admin: adminModule,
        detailing: detailingModule
    }
})